import { render } from "./QuestionsBankModal.vue?vue&type=template&id=76ac7cea"
import script from "./QuestionsBankModal.vue?vue&type=script&lang=js"
export * from "./QuestionsBankModal.vue?vue&type=script&lang=js"

import "./QuestionsBankModal.vue?vue&type=style&index=0&id=76ac7cea&lang=css"
script.render = render

export default script